import React, { useEffect } from 'react';

import { Divider, Typography } from '@telus-uds/components-web';

import { Container, Wrapper } from './css';
import NewPhoneNumberCheck from './newPhoneNumberCheck';
import ExistingPhoneNumberCheck from './existingPhoneNumberCheck';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const PhonePortingTool = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    portabilityTool: { labelCheckService }
  } = localizedStrings;

  useEffect(() => {
    const footer = document.getElementById('footer');
    const root = document.getElementById('root');

    // Only pin the footer to the viewport bottom when the page content is shorter
    // than the viewport - otherwise (e.g. at higher browser zoom levels) the fixed
    // footer overlaps the scrollable content and blocks wheel-scrolling past it.
    const updateFooterPosition = () => {
      if (root && root.scrollHeight <= root.clientHeight) {
        footer.style.position = 'fixed';
        footer.style.bottom = '0';
      } else {
        footer.style.position = null;
        footer.style.bottom = null;
      }
    };

    updateFooterPosition();
    window.addEventListener('resize', updateFooterPosition);

    return () => {
      window.removeEventListener('resize', updateFooterPosition);
      footer.style.position = null;
      footer.style.bottom = null;
    };
  }, []);

  return (
    <Container>
      <Typography heading="h1" variant={{ size: 'h1' }} block>
        {labelCheckService}
      </Typography>
      <Wrapper>
        <NewPhoneNumberCheck />
        <Divider space={3} variant={{ inverse: true }} />
        <ExistingPhoneNumberCheck />
      </Wrapper>
    </Container>
  );
};

export default PhonePortingTool;
